<template>
  <a-row
    :gutter="16"
  >
    <a-col :span="12">
      <div style="height:30px">
        省份
      </div>
      <a-select
        placeholder="请选择省份"
        :value="province"
        @select="handleSelect"
        @change="handleChangeProvince"
      >
        <a-select-option
          v-for="item in provinceData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </a-col>
    <a-col
      v-show="cityShow"
      :span="12"
    >
      <div style="height:30px">
        城市
      </div>
      <a-select
        placeholder="请选择城市"
        :value="city"
        @change="handleChangeCity"
      >
        <a-spin
          v-if="cityLoading"
          slot="notFoundContent"
          size="small"
        />
        <a-select-option
          v-for="item in cityData"
          v-else
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: ['value'],
  data() {
    const value = this.value || {};
    return {
      provinceData: [],
      cityData: [],
      province: value.province,
      city: value.city,
      path: '',
      cityLoading: true,
      cityShow: false,
    };
  },
  watch: {
    value(val = {}) {
      this.province = val.province;
      this.city = val.city;
    },
    province(val) {
      this.handleSelect(val);
      this.city = this.$props.value.city;
    },
  },
  async mounted() {
    // 获取省市
    let result = await this.$http.post('/system/getRegionList');
    if (result.data.status === 1) {
      this.provinceData = result.data.data;
    }
    // //省市回显TODO:
    // console.log(this.city);
    // if (this.province) {
    //   let result = await this.$http.post('/system/getRegionList', {
    //     pid: this.province,
    //   });
    //   if (result.data.status === 1) {
    //     this.cityLoading = false;
    //     this.cityData = result.data.data;
    //   }
    // }
  },

  methods: {
    // 选中省份
    async handleSelect(key) {
      this.city = '';
      if(key>4){
        this.cityShow = true;
      }else{
        this.cityShow = false;
      }
      let result = await this.$http.post('/system/getRegionList', {
        pid: key,
      });
      if (result.data.status === 1) {
        this.cityLoading = false;
        this.cityData = result.data.data;
      }
    },
    // change 省份
    handleChangeProvince(value) {
      this.$emit('change', {
        province: value,
        city: this.city,
      });
    },
    // change 城市
    handleChangeCity(value) {
      this.$emit('change', {
        province: this.province,
        city: value,
      });
    },
  },
};
</script>
